import { SourceType } from "@tandemdiabetes/sugarmate-api-react-client"
import { Navigate } from "@tanstack/react-router"
import { useEffect } from "react"

import { AddDataSourceButtons } from "./AddDataSourceButtons"
import styles from "./DataSource.module.scss"
import { DataSourceComponent } from "./DataSourceComponent"
import { NightscoutDelay } from "./NightscoutDelay"
import { SourceConnectDialog } from "./SourceConnectDialog"
import { TandemNotice } from "./TandemNotice"
import { WarningDialogs } from "./WarningDialogs"
import { PageTemplate } from "src/components"
import { usePolyglot } from "src/contexts"
import {
  useSources,
  useIsOnboardingSource,
} from "src/hooks"

const polyglotPrefix = "pages.settings.data_source."

/*
 * TODO consent dialog should be separate page ?
 * TODO should tandem logo change its color ?
 * TODO update text for TODO items
 */
export function DataSource() {
  const polyglot = usePolyglot()

  const {
    data: sources,
  } = useSources()

  const [
    isOnboardingSource,
    setIsOnboardingSource,
  ] = useIsOnboardingSource()

  // clear the value in local storage that tells us to resume onboarding after dexcom redirects
  useEffect(
    () => {
      if (isOnboardingSource) {
        setIsOnboardingSource(false)
      }
    },
    [
      isOnboardingSource,
      setIsOnboardingSource,
    ],
  )

  // respect the value in local storage that tells us to resume onboarding after dexcom redirects
  if (isOnboardingSource) {
    return (
      <Navigate
        to="/onboarding/data_source"
        search={Object.fromEntries(new URLSearchParams(window.location.search))}
        replace
      />
    )
  }

  // TODO
  if (!sources) {
    return null
  }

  const source = sources[0]

  return (
    <PageTemplate
      user="account"
      title={polyglot.t("components.page_header.pages.data_source")}
      backRoutePath="/account"
    >
      <WarningDialogs source={source}/>
      <SourceConnectDialog>
        <div className={styles.container}>
          <div
            className={styles.disclaimer}
            id="dosage-notice"
          >
            {polyglot.t(`${polyglotPrefix}disclaimer`)}
          </div>
          <hr className={styles.hr} />
          <div className={styles.textContainer}>
            <div className={styles.description}>
              {polyglot.t(`${polyglotPrefix}description`)}
            </div>
            {source ? (
              <DataSourceComponent source={source} />
            ) : (
              <>
                <div className={styles.description}>
                  {polyglot.t(`${polyglotPrefix}no_source_message`)}
                </div>
                <div className={styles.selectMessage}>
                  {polyglot.t(`${polyglotPrefix}select_data_source`)}
                </div>
              </>
            )}
          </div>
          {!source && (
            <AddDataSourceButtons />
          )}
          <NightscoutDelay />
          {source?.source_type === SourceType.Tandem && <TandemNotice />}
        </div>
      </SourceConnectDialog>
    </PageTemplate>
  )
}
